import { grey } from "@material-ui/core/colors";

declare module "@material-ui/core/styles/createPalette" {
  interface Palette {
    white: React.CSSProperties["color"];
    black: React.CSSProperties["color"];
    header: React.CSSProperties["color"];
    gray: Palette["primary"];
    blue: Palette["primary"];
  }
  interface PaletteOptions {
    white: React.CSSProperties["color"];
    black: React.CSSProperties["color"];
    header: React.CSSProperties["color"];
    gray: PaletteOptions["primary"];
    blue: PaletteOptions["primary"];
  }
}

export const paletteColors = {
  white: "#FFFFFF",
  black: "#000000",
  header: "#212121",
  primary: {
    light: "#84A3EC",
    main: "#5175B9",
    dark: "#164A89",
    contrastText: "#FFFFFF",
    buttonHover: "#073286",
  },
  secondary: {
    light: "#D2D2D2",
    main: "#A1A1A1",
    dark: "#737373",
    contrastText: "#FFFFFF",
  },
  info: {
    light: "#5DABF0",
    main: "#137CBD",
    dark: "#00508C",
    contrastText: "#FFFFFF",
  },
  error: {
    light: "#FF6D40",
    main: "#D73912",
    dark: "#9E0000",
    contrastText: "#FFFFFF",
  },
  warning: {
    light: "#FFF05D",
    main: "#FABE24",
    dark: "#C28E00",
    contrastText: "#000000",
  },
  success: {
    light: "#4FB882",
    main: "#0E8755",
    dark: "#00592C",
    contrastText: "#FFFFFF",
  },
  /*
    Escala de Cinza:
    - 50: #FAFAFA
    - 100: #F5F5F5
    - 200: #EEEEEE
    - 300: #E0E0E0
    - 400: #BDBDBD
    - 500: #9E9E9E
    - 600: #757575
    - 700: #616161
    - 800: #424242
    - 900: #212121
  */
  gray: {
    ...grey,
    light: grey[50],
    main: grey[400],
    dark: grey[900],
  },
  blue: {
    light: "#E2FEFF",
    main: "#AFCBFF",
    dark: "#7E9ACC",
    contrastText: "#000000",
  },
};
